import { Step, StepConnector, StepIconProps, StepLabel, Stepper, Typography } from '@mui/material';
import { makeStyles, withStyles } from 'tss-react/mui';
import { FormElement } from '@uplift/types';
import React from 'react';
import { useRenderFormContext } from '../render/render-form.context';
import { CheckCircle } from '@mui/icons-material';

const DottedConnector = withStyles(StepConnector, {
  line: {
    borderLeftStyle: 'dashed',
  },
  vertical: {
    padding: 0
  }
});

const useStepIconStyles = makeStyles<void, 'active' | 'circle' | 'completed'>({ name: 'divider-stepper' })((theme, _params, classes) => ({
  active: { },
  circle: { },
  completed: { },
  dot: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: '50%',
    height: '6px',
    width: '6px',
    zIndex: 2,
  },
  root: {
    alignItems: 'center',
    display: 'flex',
    [`&.${classes.active}`]: {
      border: `1px solid ${theme.palette.secondary.main}`,
      borderRadius: '50%',
      display: 'grid',
      height: '24px',
      placeItems: 'center',
      width: '24px',
    },
    [`&.${classes.circle}`]: {
      background: theme.palette.common.white,
      border: '1px solid rgba(0, 0, 0, 0.23)',
      borderRadius: '50%',
      height: '24px',
      width: '24px',
    },
    [`&.${classes.completed}`]: {
      fill: theme.palette.secondary.main,
    }
  }
}));

const DividerStepIcon: React.VFC<StepIconProps> = ({ active, completed }) => {
  const { classes, cx } = useStepIconStyles();
  const appliedClassName = cx(classes.root, {
    [classes.circle]: !active && !completed,
    [classes.active]: active,
    [classes.completed]: completed,
  });

  if (completed) {
    return <CheckCircle className={appliedClassName} />;
  }

  if (active) {
    return (
      <div className={appliedClassName}>
        <div className={classes.dot} />
      </div>
    );
  }

  return (
    <div className={appliedClassName} />
  );
};

const useStepLabelStyles = makeStyles()(() => ({
  labelContainer: {
    '& > span': {
      marginTop: '4px !important'
    }
  }
}));

export type SectionDividerProps = {
  element: FormElement;
};

export const SectionDivider: React.VFC<SectionDividerProps> = ({ element }) => {
  const { state } = useRenderFormContext();
  const { groups } = state;
  const { classes } = useStepLabelStyles();

  const activeGroup = groups.findIndex(x => x.formGroupId === element.formGroupId);

  return (
    <Stepper orientation="vertical" activeStep={activeGroup} connector={<DottedConnector />}>
      {groups.map(x => (
        <Step key={`step-${x.formGroupId}`}>
          <StepLabel StepIconComponent={DividerStepIcon} classes={classes}>
            <Typography variant="h4">
              {x.name}
            </Typography>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};
